import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "feature-toggler" }, [
    _c(
      "div",
      {
        staticClass: "feature-toggler__validation",
        class: {
          "feature-toggler__validation--invalid": _vm.hasValidationErrors,
          "feature-toggler__validation--valid": !_vm.hasValidationErrors,
        },
      },
      [
        _vm.validationLoading
          ? _c("span", [_vm._v("Validating...")])
          : !_vm.hasValidationErrors
          ? _c("span", [_vm._v("No validation errors.")])
          : [
              _vm.flagErrors.length > 0
                ? _c(
                    "div",
                    { staticClass: "feature-toggler__validation-section" },
                    [
                      _c("b", [_vm._v("Flag validation errors")]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        _vm._l(_vm.flagErrors, function (error) {
                          return _c("li", { key: `flag-${error}` }, [
                            _vm._v(_vm._s(error)),
                          ])
                        }),
                        0
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.orderErrors.length > 0
                ? _c(
                    "div",
                    { staticClass: "feature-toggler__validation-section" },
                    [
                      _c("b", [_vm._v("Order config validation errors")]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        _vm._l(_vm.orderErrors, function (error) {
                          return _c("li", { key: `order-${error}` }, [
                            _vm._v(_vm._s(error)),
                          ])
                        }),
                        0
                      ),
                    ]
                  )
                : _vm._e(),
            ],
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "feature-toggler__toggles" },
      _vm._l(
        { ..._vm.releaseFlags, ..._vm.toggleLogic },
        function (value, key) {
          return _c(
            "div",
            { key: key, staticClass: "feature-toggler__toggles--toggle" },
            [
              _c("b", [_vm._v(_vm._s(key) + ":")]),
              _vm._v(" "),
              _vm.isBoolean(value)
                ? _c(VSwitch, {
                    attrs: { "input-value": value },
                    on: {
                      change: function ($event) {
                        return _vm.debouncedUpdateToggle({ key, value: $event })
                      },
                    },
                  })
                : _vm.isString(value)
                ? _c(VTextField, {
                    attrs: { value: String(value) },
                    on: {
                      input: function ($event) {
                        return _vm.debouncedUpdateToggle({ key, value: $event })
                      },
                    },
                  })
                : _vm.isObject(value) || _vm.isNumber(value)
                ? _c(VTextField, {
                    attrs: { value: JSON.stringify(value) },
                    on: {
                      input: function ($event) {
                        return _vm.debouncedUpdateToggle({
                          key,
                          value: $event,
                          parse: true,
                        })
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(value))]),
            ],
            1
          )
        }
      ),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }